export default "__VITE_ASSET__gyXEY8Xs__"